module.exports = __webpack_public_path__ + "img/fis-coloured-white-txt.09249422.svg";